<template>
  <div>
    <div class="hello">
      <div
        style="padding: 10px;background: linear-gradient(to bottom right, rgb(24, 95, 155), rgb(24, 95, 155));text-align: left;font-size:1.1rem;height:2rem;"
      >
        <img
          src="https://www.ptty.com.cn/wap/lnyy.png?v=20260617"
          style="width:42px;position: absolute;top:5px;"
        />
        <label
          style="position: absolute;left: 62px;top:16px;font-weight: 700;color: #fff;"
        >
          辽宁优羽
        </label>

        <label
          style="position: absolute;right: 60px;top:13px;font-weight: 700;color: #fff;"
        >
          跑兔体育
        </label>
        <img
          src="https://www.ptty.com.cn/wap/logo_b.png?v=20250530"
          style="position: absolute;width:39px;right:10px;top:5px;"
        />
      </div>
    </div>
    <van-pull-refresh
      v-model="isLoading"
      @refresh="onRefresh"
      :disabled="!isAtTop"
    >
      <div
        style="padding: 10px;background: linear-gradient(to right bottom, rgb(24, 95, 155), rgb(0 136 250));text-align: left;"
      >
        <van-field
          v-model="search.info"
          left-icon="search"
          center
          clearable
          label=""
          placeholder="请输入项目信息"
        >
          <template #button>
            <van-button size="small" type="primary" @click="searchHandler"
              >检索</van-button
            >
          </template>
        </van-field>

        <div style="padding-top:15px;padding-bottom:10px;">
          <label class="dropClass" @click="openQslxModal">
            <span>{{
              qslxSelectData.name === "全部" ? "比赛类型" : qslxSelectData.name
            }}</span
            ><van-icon name="arrow-down" />
          </label>
          <label class="dropClass" @click="openBsztModal">
            <span>{{
              bsztSelectData.name === "全部" ? "比赛状态" : bsztSelectData.name
            }}</span
            ><van-icon name="arrow-down" />
          </label>
        </div>
      </div>

      <div
        class="itemContentMain"
        v-for="(item, index) in resultList"
        :key="index"
        @click="navToUrl(item.SSIDEN)"
      >
        <div
          v-if="item.FWCS > 100"
          style="position: absolute;top: 5px;left: 12px;color: rgb(118 117 117);font-size:14px;"
        >
          <van-icon name="eye-o" />
          {{ item.FWCS }}
        </div>
        <div
          style="position: absolute;right: 0px;top: 0px;"
          v-if="item.BSZT.length > 0"
        >
          <van-tag
            :type="
              item.BSZT === '1'
                ? 'primary'
                : item.BSZT === '3'
                ? 'danger'
                : item.BSZT === '6'
                ? 'warning'
                : item.BSZT === '7'
                ? 'success'
                : ''
            "
          >
            {{
              item.BSZT === "1"
                ? "报名中"
                : item.BSZT === "3"
                ? "排赛中"
                : item.BSZT === "6"
                ? "比赛中"
                : item.BSZT === "7"
                ? "比赛结束"
                : ""
            }}
          </van-tag>
        </div>
        <van-row>
          <van-col span="6">
            <van-image
              round
              width="60px"
              height="60px"
              :src="
                item.IMGURL.length > 0
                  ? item.IMGURL
                  : 'https://www.ptty.com.cn/wap/logo.png?v=20250530'
              "
            />
          </van-col>
          <van-col span="18">
            <div class="textMainDiv">
              <div
                style="font-size: 16px;font-weight: 800;padding-bottom: 5px;"
              >
                {{ item.SSMC }}
              </div>
              <div style="font-size: 13px;color: #8d8d8d;padding-bottom: 5px;">
                比赛日期：{{ item.BSQSRQ }} 至 {{ item.BSJZRQ }}
              </div>
              <div style="font-size: 13px;color: #8d8d8d;padding-bottom: 5px;">
                比赛地址：{{ item.CGMC }}
              </div>
              <div
                style="font-size: 13px;color: #8d8d8d;padding-bottom: 5px;"
                v-if="item.BMQSRQ.length > 0"
              >
                报名起始时间：{{ item.BMQSRQ }}
              </div>
              <div
                style="font-size: 13px;color: #8d8d8d;padding-bottom: 5px;"
                v-if="item.BMQSRQ.length > 0"
              >
                报名截止时间：{{ item.BMJZRQ }}
              </div>
            </div>
          </van-col>
        </van-row>
      </div>

      <div
        style="text-align: center;margin-top: 15px;font-size:13px;color:rgb(104, 104, 104)"
        @click="loadingGdHandler"
        v-if="resultList.length > 0"
      >
        <span>{{ isEndPage ? "已加载全部" : "点击加载更多" }}</span>
        <van-icon name="arrow-down" v-if="!isEndPage" />
      </div>
      <van-empty description="数据不存在" v-if="resultList.length === 0" />

      <div style="height:200px;width:15px;"></div>
    </van-pull-refresh>
    <!--比赛类型  开始-->
    <van-action-sheet
      v-model="qslxVisible"
      :actions="qxlxActive"
      @select="onQslxSelect"
    />
    <!--比赛类型  结束-->

    <!--比赛状态  开始-->
    <van-action-sheet
      v-model="bsztShow"
      :actions="bsztActions"
      @select="onBsztSelect"
    />
    <!--比赛状态  结束-->

    <!-- 底部导航栏 开始 -->
    <van-tabbar v-model="bottomMenuActive" v-if="false">
      <van-tabbar-item icon="home-o" @click="tabNavToUrl">主页</van-tabbar-item>
      <van-tabbar-item icon="user-o" @click="tabNavToUrl"
        >个人中心</van-tabbar-item
      >
    </van-tabbar>
    <!-- 底部导航栏 结束 -->

    <div
      style="    position: fixed;
    bottom: 0px;
    width: 100%;
    height: 46px;
    background: rgb(104, 104, 104);
    font-size: 15px;
    color: rgb(255, 255, 255);
    margin-top: 10px;
    margin-bottom: 5px;
    text-align: center;"
    >
      <div
        style="margin-top: 5px;
    margin-bottom: 1px;font-size: 13px;"
      >
        天津跑兔体育科技有限公司©版权所有
      </div>
      <div style="font-size: 13px;">
        <a
          style="text-decoration:none;color:#fff"
          href="http://beian.miit.gov.cn/"
          target="_blank"
          >津ICP备2023005649号</a
        >
      </div>
    </div>

    <loading-com />
  </div>
</template>

<script>
import HeaderCom from "./../commonCom/HeaderCom.vue";
import LoadingCom from "../commonCom/LoadingCom.vue";
export default {
  components: { HeaderCom, LoadingCom },
  name: "IndexLjyx",

  data() {
    return {
      resultList: [],
      isEndPage: false,
      isLoading: false,
      bottomMenuActive: 0,
      op: "wapGL",
      qslxVisible: false,
      qxlxActive: [
        { name: "全部", value: "" },
        { name: "羽毛球", value: "1" }
      ],
      bsztShow: false,
      bsztActions: [
        { name: "全部", value: "" },
        { name: "报名中", value: "1" },
        { name: "排赛中", value: "3" },
        // { name: "发布秩序册", value: "5" },
        { name: "比赛中", value: "6" },
        { name: "比赛结束", value: "7" }
      ],
      pageSet: {
        currentPage: 1, //当前页页码
        pageSize: 10, //每页默认显示的条数
        totalNums: 0 //数据总条数
      },
      search: {
        info: "",
        qslx: "",
        bszt: ""
      },
      qslxSelectData: { name: "比赛类型", value: "" },
      bsztSelectData: { name: "比赛状态", value: "" },
      isAtTop: true // 是否在顶部
    };
  },
  created() {
    this.utilPost = this.$util.handler;
  },
  mounted() {
    localStorage.setItem("routeValue", "indexLjyx");
    var openIdEn = localStorage.getItem("openIdEn");
    if (openIdEn === undefined || openIdEn === null || openIdEn.length === 0) {
      this.utilPost.getOpenId(function(openId) {});
    }
    this.resultList = [];
    //必须等界面渲染完成后 在加载
    this.mainLoadData();
    // 监听滚动事件
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    // 移除滚动监听
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    // 处理滚动事件
    handleScroll() {
      // 判断是否在顶部（允许10px的误差）
      this.isAtTop =
        window.pageYOffset <= 10 || document.documentElement.scrollTop <= 10;
    },
    searchHandler() {
      this.resultList = [];
      this.pageSet.currentPage = 1;
      this.mainLoadData();
    },
    onRefresh() {
      this.resultList = [];
      this.pageSet.currentPage = 1;
      this.mainLoadData();
    },
    loadingGdHandler() {
      if (this.isEndPage) {
        return;
      }
      this.pageSet.currentPage = this.pageSet.currentPage + 1;
      this.mainLoadData();
    },
    mainLoadData() {
      //alert(JSON.stringify(this.pageSet));
      this.search.qslx = this.qslxSelectData.value;
      this.search.bszt = this.bsztSelectData.value;
      this.search.zhlx = "WJJ001";
      var busData = {
        pageSet: this.pageSet,
        search: this.search
      };
      var paramData = {
        headerData: {
          ssid: this.ssid,
          op: this.op, //反射名称
          methodName: "getSsxx" //对应的方法名
        },
        busData: busData //参数内容
      };
      this.utilPost.paramData = paramData;
      //alert(JSON.stringify(paramData));
      this.utilPost.sendPost().then(data => {
        //alert(JSON.stringify(data));
        if (!data.isSuccess) {
          alert(data.msg);
          return;
        }

        for (var a = 0; a < data.content.length; a++) {
          this.resultList.push(data.content[a]);
        }

        if (
          data.content.length == 0 ||
          data.totalCount === this.pageSet.currentPage
        ) {
          this.isEndPage = true;
        } else {
          this.isEndPage = false;
        }
        this.isLoading = false;
      });
    },
    navToUrl(ssidEn) {
      this.$router.push({ path: "/xmIndex", query: { ssid: ssidEn } });
    },
    openQslxModal() {
      this.qslxVisible = true;
    },
    onQslxSelect(item) {
      this.pageSet.currentPage = 1;
      this.qslxSelectData = item;
      this.qslxVisible = false;
      this.resultList = [];
      this.mainLoadData();
    },
    //打开比赛状态Model
    openBsztModal() {
      this.bsztShow = true;
    },
    onBsztSelect(item) {
      this.pageSet.currentPage = 1;
      this.bsztSelectData = item;
      this.bsztShow = false;
      this.resultList = [];
      this.mainLoadData();
    },
    tabNavToUrl() {
      switch (this.bottomMenuActive) {
        case 0: {
          var routeValue = localStorage.getItem("routeValue");
          if (
            routeValue === null ||
            routeValue === undefined ||
            routeValue.length === 0
          ) {
            this.$router.push({ path: "/" });
          } else {
            this.$router.push({ path: "/" + routeValue });
          }
          break;
        }
        case 1: {
          this.$router.push({ path: "/meIndex" });
          break;
        }
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.van-field {
  padding: 3px;
  border-radius: 5px;
}
.dropClass {
  background: #ffffff4f;
  padding: 8px;
  border-radius: 5px;
  font-size: 13px;
  color: #fff;
}
.van-overlay {
  background-color: rgba(0, 0, 0, 0.5);
}
.itemContentMain {
  background: #fff;
  margin: 10px;
  padding: 10px;
  border-radius: 5px;
  position: relative;
}
.van-image--round {
  margin-top: 15px;
}
.van-tag {
  font-size: 13px;
  padding-left: 8px;
  padding-right: 8px;
  padding-top: 3px;
  padding-bottom: 3px;
}
.textMainDiv {
  padding-top: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/Index/IndexLjyx.vue